import { render } from "./RefundPage.vue?vue&type=template&id=719c1f3e&ts=true"
import script from "./RefundPage.vue?vue&type=script&lang=ts"
export * from "./RefundPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__